<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" title="BODYMATTER">
<p class="h1" id="pa1"><a href="#/text/nav#rpa1"><span class="right_1" epub:type="pagebreak" id="page_1" title="1">PART I</span></a></p>
<p class="h1a"><a href="#/text/nav#rpa1">THE CANDIDATE</a></p>
<p class="h1b"><a href="#/text/nav#rpa1">(1974–1978)</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781595554499_Part_1.vue?fe8a7fba